<template>
  <div class="zj-mobile-map map"></div>
</template>

<script>
import { Toast } from "mint-ui";

export default {
  name: "EmgMap",
  controller: "UI",
  action: "MapView",
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {
    MapKey: {
      required: true,
      type: String,
    },
    MapLayers: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
       loadingText: "加载中...",
      mapInstance: null,
      currentPoint: {}
    };
  },
  methods: {
    goCenter: function() {
      // eslint-disable-next-line no-undef
      this.mapInstance.panTo(new BMap.Point(this.center[0], this.center[1]));
    },
    layerButtonClick: function (data) {
      this.$emit("layerButtonClick",data);
    },
    addDom: function() {
      if (!this.mapInstance) return;
      var layer = this.mapInstance.getLayerByName("DOM");
      if (layer && layer.addDom) {
        // eslint-disable-next-line no-undef
        var $div = $("<div></div>");
        $div.append(this.getSvgContent());
        $div.css({
          width: "3rem",
          height: "3rem",
          "margin-left": "-1.5rem",
          "margin-top": "-1.5rem",
          position: "absolute"
        });
        layer.addDom(this.center[0], this.center[1], $div[0]);
      }
    },
    getSvgContent: function() {
      var html =
        "" +
        '<div class="svg_container">' +
        '  <div class="svg-box">' +
        '     <svg version="1.1"  x="0px" y="0px" viewBox="0 0 100 100"' +
        '         enable-background="new 0 0 100 100" xml:space="preserve">' +
        '       <circle fill="rgba(244,16,11,5)" cx="50" cy="50" r="5" />' +
        '       <circle fill="rgba(244,16,11,0.2)" cx="50" cy="50" r="20" />' +
        '       <circle fill="rgba(244,16,11,0.1)" cx="50" cy="50" r="35" />' +
        "     </svg>" +
        "  </div>" +
        // '  <div class="circle delay1"></div>' +
        // '  <div class="circle delay2"></div>' +
        // '  <div class="circle delay3"></div>' +
        "</div>";
      return html;
    },
    getCurrentPostion() {
      let that = this;
      // eslint-disable-next-line no-undef
      var geolocation = new BMap.Geolocation();
      // eslint-disable-next-line no-undef
      //var gc = new BMap.Geocoder();//创建地理编码器
      // 开启SDK辅助定位

      geolocation.enableSDKLocation();

      geolocation.getCurrentPosition(function(r) {
        // eslint-disable-next-line no-undef
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          // eslint-disable-next-line no-undef
          var mk = new BMap.Marker(r.point);

          that.mapInstance.addOverlay(mk);

          //map.panTo(r.point);

          //Toast(JSON.stringify(r.point));
          //var pt = r.point;

          //map.panTo(pt);//移动地图中心点

          // gc.getLocation(pt, function(rs){
          // 	var addComp = rs.addressComponents;
          // 	 alert(addComp.province + addComp.city + addComp.district);
          // });
        } else {
          Toast("获取地理位置失败" + this.getStatus());
        }
      });
    }
  },
   created() {
    console.debug("mapview created");
  },
  mounted() {
    // 创建地图，并通过样式让地图填满窗口
    let that = this;
    let mapkey = this.MapKey;

    var mapConfigs = {};
    if (this.MapLayers) {
      mapConfigs["mapLayers"] = this.MapLayers;
    }

    this.$nextTick(function () {
      // 不传入 syscode 和 key ，或者值为空时，
      // zjumap 插件自动从 URL 地址
      // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
      // 中读取 syscode 和 key 的值。
      // eslint-disable-next-line no-undef
      $(".map").zjumap({
        syscode: "ZJMap",
        key: mapkey,
        loading: ".global-loading",
        loadingText: ".global-loading-text",
        //地图配置
        // eslint-disable-next-line no-undef
        mapConfigs: $.extend(
          {},
          {
            //mapStyle: "styles/darknight.json",
            //toggleTool: "tool/Toggle",
            //tilesPath: "/lib/zjmap/Content/tiles/tiles",
            //zoom:16,
            //mapVender: that.MapVender,
            // mapLayers: "观光车,游船",
            // minZoom: 5, //允许的最小地图级别
            // maxZoom: 19, //允许的最大地图级别
            // zoom: 15, //默认地图级别
            // layerDefineFile: "js/layers-default.js", //图层定义文件
            // mapType: "BMAP_NOAMAL_MAP",
            // center: [106.904337, 32.957395],
            //tilt: 0,
            onMapCreated: function (e) {
              that.mapInstance = e.map;
              that.center = e.map.config.center;
              
              //that.addDom();
            },
            onLayerButtonClick: function (e) {
              var item = e.originEvent.currentTarget;
              // eslint-disable-next-line no-undef
              var action = $(item).data("action");
              var data = {
                e:e,
                action: action,
              };
              that.layerButtonClick(data);
            },
          },
          mapConfigs
        ),
        //,gotMapConfigs: function (conf, opts) { } //当从统一配置中获取到地图配置，并合并完 mapConfigs 后，触发此事件。
      });
    });
  },
  // mounted() {
  //   // 创建地图，并通过样式让地图填满窗口
  //   let that = this;

  //   this.$nextTick(function() {
  //     // eslint-disable-next-line no-undef
  //     $(function() {
  //       // 不传入 syscode 和 key ，或者值为空时，
  //       // zjumap 插件自动从 URL 地址
  //       // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
  //       // 中读取 syscode 和 key 的值。

  //       // eslint-disable-next-line no-undef
  //       $(".map").zjumap({
  //         syscode: "ZJMap",
  //         key: "EmergencyOneMap",
  //         //地图配置
  //         mapConfigs: {
  //           mapStyle: "",
  //           togglePanelVisiable: false,
  //           //tilesPath: "",
  //           clickToShowLocation: false,
  //           mapLayers: "DOM",
  //           onMapCreated: function(e) {
  //             that.mapInstance = e.map;
  //             that.center = e.map.config.center;

  //             setTimeout(() => {
  //               that.addDom();
  //             }, 1000);

  //             // setTimeout(() => {
  //             //   that.getCurrentPostion();
  //             // }, 1000);
  //           }
  //         }
  //       });
  //     });
  //   });
  // },
  beforeDestroy() {
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
      console.debug("mapview beforeDestroy");
    }
  },
  destroyed() {},
};
</script>